import { registerModal } from "@/shared/lib/modal/modal-registry";
import CreateExportConfigModal from "./create-export-config-modal";

registerModal("create-export-config", CreateExportConfigModal, {
  titleKey: "mlExports:modals.createExportConfig",
  maxWidth: 500,
});
